/**
 * 积分系统 React Query 配置
 * 统一管理查询键、缓存策略和失效逻辑
 */

import { QueryClient } from "@tanstack/react-query";

// ========== 查询键工厂 ==========
export const pointsKeys = {
  all: ["points"] as const,
  balance: () => [...pointsKeys.all, "balance"] as const,
  history: (filters?: { pageSize?: number }) =>
    [...pointsKeys.all, "history", filters] as const,
  statistics: () => [...pointsKeys.all, "statistics"] as const,
};

// ========== 缓存失效辅助函数 ==========
export const invalidatePointsQueries = {
  /**
   * 使所有积分相关查询失效
   */
  all: (queryClient: QueryClient) => {
    return queryClient.invalidateQueries({
      queryKey: pointsKeys.all,
    });
  },

  /**
   * 仅使余额查询失效
   */
  balance: (queryClient: QueryClient) => {
    return queryClient.invalidateQueries({
      queryKey: pointsKeys.balance(),
    });
  },

  /**
   * 仅使历史记录查询失效
   */
  history: (queryClient: QueryClient) => {
    return queryClient.invalidateQueries({
      queryKey: pointsKeys.history(),
    });
  },
};

// ========== 乐观更新辅助函数 ==========
export const optimisticPointsUpdate = {
  /**
   * 乐观更新余额（扣除积分）
   */
  deductBalance: (queryClient: QueryClient, amount: number) => {
    const queryKey = pointsKeys.balance();

    queryClient.setQueryData(queryKey, (old: any) => {
      if (!old) return old;
      return {
        ...old,
        balance: Math.max(0, old.balance - amount),
        frozen_balance: old.frozen_balance + amount,
      };
    });

    // 返回回滚函数
    return () => {
      queryClient.invalidateQueries({ queryKey });
    };
  },

  /**
   * 乐观更新余额（增加积分）
   */
  addBalance: (queryClient: QueryClient, amount: number) => {
    const queryKey = pointsKeys.balance();

    queryClient.setQueryData(queryKey, (old: any) => {
      if (!old) return old;
      return {
        ...old,
        balance: old.balance + amount,
      };
    });

    // 返回回滚函数
    return () => {
      queryClient.invalidateQueries({ queryKey });
    };
  },
};
